"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createRef = _interopRequireDefault(require("./createRef"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ForwardRefPolyfill =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ForwardRefPolyfill, _React$Component);

  function ForwardRefPolyfill(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.__forwardedRef = (0, _createRef.default)();
    return _this;
  }

  var _proto = ForwardRefPolyfill.prototype;

  _proto.__render = function __render() {
    return null;
  };

  _proto.getRef = function getRef() {
    // Check for `.current` first before `.value` since it's the
    // newest property name in React.
    return this.__forwardedRef.current || this.__forwardedRef.value;
  };

  _proto.render = function render() {
    return this.__render(this.props, this.__forwardedRef);
  };

  return ForwardRefPolyfill;
}(_react.default.Component);

exports.default = ForwardRefPolyfill;

_defineProperty(ForwardRefPolyfill, "displayName", 'ForwardRefPolyfill');